import { styled } from '@mui/material/styles';

const AuthWrapper = styled('div')(() => ({
  backgroundColor: 'rgb(238, 242, 246)',
  minHeight: '100vh',
}));

export default AuthWrapper;